import type { ReactNode } from 'react';
import { FolderSync, Loader2 } from 'lucide-react';
import { FolderSetup } from './FolderSetup';
import { WatchedFolderCard } from './WatchedFolderCard';
import { useWatchedFolder } from './use-watched-folder';

/**
 * "Add pages → Watch a folder": a folder on a computer (a scanner's drop folder, a share) that Paige
 * Scan watches and sends into this job, one folder per job. When the job has one, the sheet says
 * where it is and how it is doing; when it has none, it sets one up through Paige Scan on this
 * computer, because only the computer that can see the folder may name it
 * (docs/engineering/folder-monitor.md, sections 4 and 7).
 */
export function FolderSheet(): ReactNode {
  const { folder, job, error } = useWatchedFolder();
  return (
    <>
      <header className="paige-intake-head">
        <FolderSync size={26} aria-hidden="true" />
        <h2 id="paige-intake-title">Watch a folder</h2>
        <p>
          Paige Scan sends every file saved in the folder into this job, then moves it out of the
          way. One folder per job.
        </p>
      </header>
      {folder === undefined && (
        <p className="paige-scan-checking" role="status">
          <Loader2 size={16} className="paige-spin" aria-hidden="true" />
          Getting this job’s folder…
        </p>
      )}
      {folder && <WatchedFolderCard folder={folder} />}
      {folder === null && !error && <FolderSetup job={job} />}
      {error && (
        <p className="paige-scan-problem" role="alert">
          {error}
        </p>
      )}
    </>
  );
}
